<script setup>
/**
 * FormControlPagesUrlSlug
 * Headless structural modifier component.
 * Executes layout configuration mutations on mount, automatically hiding
 * its associated field reference instance from active administrative views.
 */
import { onMounted } from 'vue';

const props = defineProps({
    // Standard Orchestrator Props
    field: {
        type: Object,
        required: true
    },
    formId: {
        type: String,
        default: ''
    },
    currentData: {
        type: Object,
        default: () => ({})
    }
});

// --- Lifecycle ---

onMounted(() => {
    /**
     * Instantly apply the structural visibility lock on mount
     * to ensure the field is removed from Vite compilation tracks.
     */
    if (props.field) {
        props.field.hidden = true;
    }
});
</script>

<template>
</template>